/**
 * Placeholder pilot **avatar glyph**. Extracted so the picker (`PilotPicker`) and CODEX's registry
 * (`RolodexApp`) derive the same glyph from the same pilot — they must not drift.
 */

/** First glyph of the callsign for the placeholder avatar (uppercased), or a fallback hex. */
export function avatarGlyph(callsign: string): string {
  const trimmed = callsign.trim();
  return trimmed.length > 0 ? trimmed[0]!.toUpperCase() : "⬡";
}
